// =============================================================================
// DATENSCHUTZERKLÄRUNG
// -----------------------------------------------------------------------------
// Erklärt, dass die Seite keine Daten erhebt und keine Cookies setzt.
// Kontakt-Adressen kommen aus config.js.
// =============================================================================

import { Link } from "react-router-dom";
import { BackIcon } from "@/icons";
import { IMPRESSUM, BOOKING } from "@/config";
import Background from "@/components/Background";

export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page">
      <Background />

      <main className="legal-page">
        <Link to="/" className="legal-back" data-testid="datenschutz-back">
          <BackIcon size={14} aria-hidden="true" /> Zurück
        </Link>

        <h1 className="legal-title">Datenschutz&shy;erklärung</h1>

        <section className="legal-block">
          <h2>Allgemeines</h2>
          <p>
            Der Schutz deiner persönlichen Daten ist mir wichtig. Diese Website
            wird privat und nicht-kommerziell als Hobbyprojekt betrieben. Sie
            ist so ausgelegt, dass sie ohne die Erhebung personenbezogener
            Daten und ohne den Einsatz von Cookies oder Tracking-Diensten
            genutzt werden kann.
          </p>
        </section>

        <section className="legal-block">
          <h2>Keine Datenerhebung</h2>
          <p>
            Auf dieser Webseite werden keine personenbezogenen Daten erhoben,
            gespeichert oder verarbeitet. Es kommen keine Cookies, kein
            Analyse-Tracking (z. B. Google Analytics, PostHog, Matomo), kein
            Newsletter-Tool und keine Kommentar- oder Formular-Funktionen zum
            Einsatz.
          </p>
        </section>

        <section className="legal-block">
          <h2>Server-Logs des Hosters</h2>
          <p>
            Beim Aufruf der Seite werden – wie bei jeder Website üblich – durch
            meinen Hosting-Anbieter technische Zugriffsdaten in Server-Logs
            verarbeitet (z. B. IP-Adresse, Zeitpunkt, abgerufene Seite,
            Browsertyp). Diese Verarbeitung erfolgt durch den Hoster zum Zweck
            des Betriebs und der Sicherheit der Website. Ich selbst greife auf
            diese Logs nicht zu und werte sie nicht aus.
          </p>
        </section>

        <section className="legal-block">
          <h2>Externe Inhalte und Schriftarten</h2>
          <p>
            Alle Schriftarten und Symbole (inklusive Font Awesome) werden lokal
            von dieser Website ausgeliefert und nicht von externen Anbietern
            wie Google Fonts oder CDNs nachgeladen.
          </p>
        </section>

        <section className="legal-block">
          <h2>Anstehende Termine via Google Sheets</h2>
          <p>
            Die Liste meiner kommenden Auftritte wird live aus einer von mir
            gepflegten Google-Tabelle (veröffentlichte CSV-Datei) geladen.
            Dabei wird deine IP-Adresse an Google übertragen. Übermittelt
            werden keine personenbezogenen Daten von dir an Google durch mich,
            lediglich die technisch notwendige Anfrage zum Abruf der öffentlich
            veröffentlichten Tabelle.
          </p>
        </section>

        <section className="legal-block">
          <h2>Hinweis zu Links auf Social Media und externe Dienste</h2>
          <p>
            Diese Website enthält Links zu meinen Profilen und Inhalten auf
            externen Plattformen (Instagram, Facebook, Mixcloud, Hearthis.at,
            Soundcloud, Twitch, TechnoBase.FM, HouseTime.FM, Discord und
            Ko-fi). Es handelt sich um einfache HTML-Links: solange du sie
            nicht anklickst, werden keine Daten an diese Plattformen
            übertragen, und es werden keine Inhalte dieser Anbieter (z. B.
            Like-Buttons, Embeds) auf dieser Seite geladen.
          </p>
          <p>
            Sobald du auf einen dieser Links klickst, verlässt du diese
            Webseite, und es gelten ausschließlich die Datenschutzbestimmungen
            und Nutzungsbedingungen des jeweiligen Anbieters. Auf deren
            Inhalte und Datenverarbeitung habe ich keinen Einfluss.
          </p>
        </section>

        <section className="legal-block">
          <h2>Kontaktaufnahme per E-Mail</h2>
          <p>
            Wenn du mich per E-Mail an{" "}
            <a href={`mailto:${IMPRESSUM.contactEmail}`}>
              {IMPRESSUM.contactEmail}
            </a>{" "}
            oder{" "}
            <a href={`mailto:${BOOKING.email}`}>{BOOKING.email}</a>{" "}
            kontaktierst, werden die von dir übermittelten Daten
            (insbesondere E-Mail-Adresse, Inhalt der Nachricht) ausschließlich
            zur Bearbeitung deiner Anfrage verwendet und nicht an Dritte
            weitergegeben. Eine Speicherung erfolgt nur, solange dies zur
            Bearbeitung der Anfrage erforderlich ist.
          </p>
        </section>

        <section className="legal-block">
          <h2>Deine Rechte</h2>
          <p>
            Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung
            oder Einschränkung der Verarbeitung deiner gespeicherten
            personenbezogenen Daten sowie ein Widerspruchsrecht und das Recht
            auf Datenübertragbarkeit nach DSGVO. Wende dich dafür einfach per
            E-Mail an{" "}
            <a href={`mailto:${IMPRESSUM.contactEmail}`}>
              {IMPRESSUM.contactEmail}
            </a>
            . Außerdem steht dir ein Beschwerderecht bei der zuständigen
            Aufsichtsbehörde zu.
          </p>
        </section>

        <Link
          to="/"
          className="legal-back legal-back-bottom"
          data-testid="datenschutz-back-bottom"
        >
          <BackIcon size={14} aria-hidden="true" /> Zurück zur Startseite
        </Link>
      </main>
    </div>
  );
}
